import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Col, Row, Container, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../DataRow';
import NotificationEdit from '../NotificationEdit';
import DynamicNotificationEdit from '../DynamicNotificationEdit';
import Action from '../Action';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class ActionEdit extends React.Component {
    constructor(props) {
        super(props);
        let defaultAction = {
            name: '',
            description: '',
            action_type: 'notification',
            config_mode: 1
        };
        if (this.props.action) {
            defaultAction = this.props.action;
        }
        this.state = {
            action: defaultAction,
            originalAction: defaultAction,
            isAddNew: this.props.isAddNew || false,
            isEdit: this.props.isEdit || false,
            isLoading: false,
            isValidating: false,
            segmentUserCount: 0,
            validationError: '',
        };
    }
    componentWillMount() {
        const { action } = this.state;
        if (action && action.id) {
            this.getAction();
        }
    }
    componentDidMount = () => {
        
    }
    getAction() {
        const { action } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `action/${action.id}`,
            success: (response) => {
                this.setState({
                    action: response.action,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    saveAction() {
        const { action, isAddNew } = this.state;
        const { segment, onSave } = this.props;

        if (!action.segment_id) action.segment_id = segment.id;

        let method = 'put';
        if (isAddNew) {
            method = 'post';
        }
        api.fetchAPI({
            method,
            uri: `actions`,
            body: action,
            success: (response) => {
                if (response.status == 'ok') {
                    this.setState({
                        action: response.action,
                        isEdit: false,
                        isAddNew: false,
                    });
                    if (onSave) {
                        onSave();
                    }
                } else {
                    alert(response.message);
                } 
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    setNotification(notification) {
        const { action } = this.state;
        action.configs = notification;
        this.setState({ action });
    }
    updateAttr(attribute, value) {
        console.log(`Update ${attribute} with ${value}`);
        const { action } = this.state;
        action[attribute] = value;
        this.setState({ action });
    }
    cancelEditAction() {
        const { originalAction } = this.state;
        this.setState({
            action: originalAction,
            isEdit: false,
            isAddNew: false,
        });
    }
    render() {
        const {
            action, isAddNew, isEdit,
        } = this.state;
        if (!action) return null;
        if (!isEdit && !isAddNew) return <Action action={action} />
        console.log(action)
        return (
            <div>
                {isAddNew &&
                    <h4>Create new action</h4>
                }
                <FormGroup>
                    <Label>Name</Label>
                    <Input
                        type="text"
                        value={action.name}
                        placeholder="Send notification to user who love TCDP..."
                        onChange={(e) => this.updateAttr('name', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Description</Label>
                    <TextareaAutosize
                        className="form-control"
                        type="textarea"
                        value={action.description}
                        placeholder="Love you to the moon and back..."
                        onChange={(e) => this.updateAttr('description', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Action type</Label>
                    <Input
                        type="select"
                        value={action.action_type ? action.action_type : "notification"}
                        onChange={(e) => this.updateAttr('action_type', e.target.value)}
                    >
                        <option value="notification">OneSignal Notification</option>
                        <option value="xenforo_alert">XenForo Alert</option>
                        <option value="dummy">dummy</option>
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label>CRON schedule</Label>
                    <Input
                        type="text"
                        value={action.schedule_cron_string}
                        placeholder="0 0 * * *"
                        onChange={(e) => this.updateAttr('schedule_cron_string', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <div className="checkbox">
                        <Input 
                            type="checkbox"
                            checked={action.do_not_resend}
                            value={action.do_not_resend}
                            onChange={() => this.updateAttr('do_not_resend', !action.do_not_resend)}
                        />
                        <Label>Do not resend</Label>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div className="checkbox">
                        <Input 
                            type="checkbox"
                            checked={action.do_not_resend_after_read}
                            value={action.do_not_resend_after_read}
                            onChange={() => this.updateAttr('do_not_resend_after_read', !action.do_not_resend_after_read)}
                        />
                        <Label>Do not resend after read</Label>
                    </div>
                </FormGroup>
                <FormGroup>
                    <Label>Do not send to users if they had received any notification within (minutes)</Label>
                    <Input 
                        type="number"
                        value={action.do_not_send_user_within_minutes}
                        onChange={(e) => this.updateAttr('do_not_send_user_within_minutes', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Set time delay between each user batch (minutes)</Label>
                    <Input 
                        type="number"
                        value={action.delay_between_batches_minutes}
                        onChange={(e) => this.updateAttr('delay_between_batches_minutes', e.target.value)}
                    />
                </FormGroup>
                {action.action_type === 'notification' &&
                    <FormGroup>
                        <Label>Content config mode</Label>
                        <Input
                            type="select"
                            value={action.config_mode ? action.config_mode : 1}
                            onChange={(e) => this.updateAttr('config_mode', parseInt(e.target.value, 10))}
                        >
                            <option value="1">Manual</option>
                            <option value="2">Dynamic</option>
                        </Input>
                    </FormGroup>
                }
                {action.action_type &&
                    <div>
                        {(action.action_type === 'notification' ||  action.action_type === 'dummy' || action.action_type === 'xenforo_alert') && action.config_mode === 1 &&
                            <NotificationEdit
                                notification={action.configs}
                                onSave={(notification) => this.setNotification(notification)}
                            />
                        }
                        {action.action_type === 'notification' && action.config_mode === 2 &&
                            <DynamicNotificationEdit
                                notification={action.configs}
                                onSave={(notification) => this.setNotification(notification)}
                            />
                        }
                    </div>
                }
                <FormGroup>
                    <Button color="success" onClick={() => this.saveAction()}>Save</Button>
                </FormGroup>
                <FormGroup>
                    <Button color="danger" onClick={() => this.cancelEditAction()}>Cancel</Button>
                </FormGroup>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/ActionEdit/index.js